import { useContext } from 'react'
import { SoundOnIcon, SoundOffIcon } from 'ui/src/icons/player'
import { CurationContext } from '@/app/(site)/edit/gifs/curation-context'

const SoundToggle = () => {
    const { soundOn, setSoundOn } = useContext(CurationContext)

    return (
        <div className="z-10 flex items-center text-xl font-bold">
            <div
                className="flex h-8 w-[103px] cursor-pointer items-center justify-center rounded-full transition-all duration-200 hover:opacity-80"
                style={{
                    background: soundOn
                        ? 'linear-gradient(-135deg, rgb(0, 187, 221) 0%, rgb(0, 231, 149) 100%)'
                        : 'linear-gradient(-135deg, rgb(148, 56, 255) 0%, rgb(74, 144, 226) 100%)',
                }}
                onClick={() => setSoundOn(!soundOn)}
            >
                <div className="flex h-6 w-6 items-center justify-center text-white">
                    {soundOn ? <SoundOnIcon /> : <SoundOffIcon />}
                </div>
            </div>
        </div>
    )
}

export default SoundToggle
